import styled from 'styled-components';

export default styled.div`
  display: flex;
  height: 400px;

  .MuiPaper-root {
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 100%;
    box-sizing: border-box;

    &:first-child {
      margin-right: 10px;
      overflow: auto;
    }
    &:last-child {
      margin-left: 10px;

      li:first-child {
        padding-top: 0;
      }
    }

    .list-content {
      overflow: auto;
    }
  }

  .MuiAutocomplete-root {
    width: 100%;
  }

  .list-content {
    button {
      border: 1px solid;
      margin: 0 6px;

      &:not(:disabled) {
        border-color: transparent;
      }
    }

    .item {
      .MuiTextField-root {
        flex-grow: 1;
      }
    }

    .has-icon {
      margin-right: 10px;
    }
  }
`;
